<template>
	<div class="row">
		<div class="col-md-6">
			<card header-classes="bg-dark">
				<template slot="header">
					<h3 class="mb-0 text-white">ตั้งค่าโบนัส</h3>
				</template>
				<div>
					<base-button type="primary" @click="openAddBonus = true">
						เพิ่มโบนัส
					</base-button>

					<div
						class="bonus-item"
						v-for="(bonus, k) in promotions"
						:key="k"
					>
						<div class="bonus-item-info">
							<h3 class="text-white mb-0">
								<i
									class="fas fa-circle mr-1"
									:class="{
										'text-success': bonus.enable,
										'text-danger': !bonus.enable,
									}"
								/>
								<span v-if="bonus.order != 0">
									({{ bonus.order }})
								</span>
								{{ bonus.name }}
							</h3>
							<h6 class="text-white mb-0 font-weight-normal">
								{{ bonus.description }}
							</h6>
						</div>
						<div class="bonus-item-action">
							<base-button
								type="primary"
								size="sm"
								@click="openEditBonus = bonus"
							>
								แก้ไข
							</base-button>
							<base-button
								type="danger"
								size="sm"
								@click="deleteBonus(bonus.key)"
								:disabled="deleting"
							>
								ลบ
							</base-button>
						</div>
					</div>
				</div>
			</card>

			<add-bonus-modal
				:open="openAddBonus"
				@close="openAddBonus = false"
				@reload="reload"
			/>
			<edit-bonus-modal
				:open="openEditBonus"
				@close="openEditBonus = null"
				@reload="reload"
			/>
		</div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui'
import AddBonusModal from '../backend-components/Bonus/AddBonusModal'
import EditBonusModal from '../backend-components/Bonus/EditBonusModal'

import BonusService from '../services/bonus.service'
import { mapGetters } from 'vuex'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		AddBonusModal,
		EditBonusModal,
	},
	data() {
		return {
			loading: false,
			deleting: false,
			promotions: {},

			openAddBonus: false,
			openEditBonus: null,
		}
	},
	computed: {
		...mapGetters('auth', ['hasFeature']),
	},
	methods: {
		reload() {
			BonusService.fetchBonus().then((res) => {
				const sortable = []
				for (let k in res) {
					res[k].key = k
					sortable.push(res[k])
				}

				sortable.sort((a, b) => {
					if (!a.enable) {
						return 1
					} else if (!b.enable) {
						return -1
					} else {
						if (a.order != 0) {
							if (b.order == 0) {
								return -1
							}
							if (a.order < b.order) {
								return -1
							} else {
								return 1
							}
						}
					}
					return 0
				})

				this.promotions = sortable
			})
		},
		async deleteBonus(key) {
			this.deleting = true

			try {
				const res = await BonusService.deleteBonus(key)

				this.reload()
				this.$notify({
					type: 'success',
					message: res.message,
				})
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.deleting = false
			}
		},
	},
	created() {
		this.reload()
	},
}
</script>
